import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 no-underline">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl text-primary-500"></i>
              </div>
              <span className="text-xl font-heading font-bold text-foreground-950 whitespace-nowrap">
                韩漫之家
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              韩漫免费漫画在线 — 精选好看韩国漫画，支持下拉式阅读，让您流畅浏览每一页。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#quick-links" className="no-underline text-foreground-900">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  全部分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#categories" className="no-underline text-foreground-900">热门分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.filter(c => c.slug !== 'all').slice(0, 5).map(cat => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#contact" className="no-underline text-foreground-900">联系我们</a>
            </h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-xs"></i>
                </span>
                contact@hanmanzhijia.com
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-customer-service-line text-xs"></i>
                </span>
                在线客服：工作日 9:00-18:00
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫之家 — 韩漫免费漫画在线阅读平台。本站内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}